module.exports = __webpack_public_path__ + "img/expand-wide.391a4406.svg";